import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { DirtyGuardProvider } from './hooks/useDirtyGuard';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <DirtyGuardProvider>
        <App />
      </DirtyGuardProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
